<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin"></div>
        <div class="page-content sm:px-8">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="privilege"></MenuDesktop>
            <div class="px-2 mt-7">
                <LoginMobile :modalController="modalController"></LoginMobile>
            </div>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25">
                <DashboardSlider :apiConfig="dashboardHomeConfig"></DashboardSlider>
                <div class="bg-tc-gray-5 sm:bg-opacity-0 p-4 sm:p-0 mt-11">
                    <CategoryList
                            ref="cate-list"
                            :categoryConfig="categoryConfig"
                            :modalController="modalController"
                    ></CategoryList>
                    <div class="mt-28">
                        <div class="w-full fixed left-0 bottom-0 bg-tc-gray-5 px-2 pb-4">
                            <MenuMobile activeMenu="privilege"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import MenuMobile from '@/components/Layout/MenuMobile/MenuMobile.vue';
import DashboardSlider from '@/components/Dashboard/DashboardPrivilegeSlider.vue';
import CategoryList from '../component/CategoryList/CategoryList.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import LoginMobile from '@/components/Layout/LoginMobile/LoginMobile.vue';

//service
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
//mixin
import ModalMixin from '@/mixin/ModalMixin';

export default {
    name: 'Privilege',
    mixins: [ModalMixin],
    components: {
        TopBar,
        MenuDesktop,
        DashboardSlider,
        CategoryList,
        BottomBar,
        MenuMobile,
        LoginMobile
    },
    data: function() {
        return {
            dashboardHomeConfig: ConfigManager.getDashboardReward(),
            cateMenuConfig: ConfigManager.getCategoryMenuPrivilege(),
            categoryConfig: null,
            form:{
                firstname: '',
                point: 0,
                profileImageUrl: ''
            },
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialCategory();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        initialCategory: function () {
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(this.cateMenuConfig)
                .setLocale(this.localeCode)
                .create();
            // Util.log('str cate config', this.cateMenuConfig);
            // Util.log('cate config', categoryConfig);

            this.categoryConfig = categoryConfig;
        },

        loadMore: function() {
            this.$refs['cate-list'].loadMore();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
